import axios from 'axios';
import LocalStorage from '../hook/LocalStorage';

const { access_token } = LocalStorage()

// export const downloadUrl = 'https://dev.thehaylo.com.au/api/'
export const downloadUrl = 'https://contents.thehaylo.com.au/api/'
// export const downloadUrl = 'http://localhost:8000/api/'

const http = axios.create({
  // baseURL: "https://dev.thehaylo.com.au/api/v1/",
  baseURL: "https://contents.thehaylo.com.au/api/v1/",
  // baseURL: "http://localhost:8000/api/v1/",
  headers: {
    'Authorization': `Bearer ${access_token}`,
    "Content-type": "application/json"
  }
});



export const httpUser = axios.create({
  // baseURL: "https://dev.thehaylo.com.au/api",
  baseURL: "https://contents.thehaylo.com.au/api",
  // baseURL: "http://localhost:8000/api",
  headers: {
    'Authorization': `Bearer ${access_token}`,
    "Content-type": "application/json"
  }
})

export const baseURLPublic = axios.create({
  // baseURL: "https://dev.thehaylo.com.au/api/v1/",
  baseURL: "https://contents.thehaylo.com.au/api/v1/",
  // baseURL: "http://localhost:8000/api/v1/",
  headers: {
    "Content-type": "application/json"
  }
});


http.interceptors.response.use(
  function (response) {
    if (response.data.token) {
      localStorage.setItem("token_verify", response.data.token);
      localStorage.setItem("users", JSON.stringify(response.data.user));
    }
    return response;
  },
  function (error) {
    if (error.response.status === 500) {
      // window.location.href = '/error'
    }
    else if (error.response.status === 401) {
      localStorage.removeItem("token_verify")
      localStorage.removeItem("users")
      window.location.href = '/'
    }
    return Promise.reject(error);
  }
)


// export const mediaUrl = 'http://127.0.0.1:8000/storage';
// export const mediaUrl = 'https://dev.thehaylo.com.au/storage';
// export const imageURL = 'http://127.0.0.1:8000';
// export const URL_S3 = 'https://haylo-test.s3.ap-southeast-2.amazonaws.com/';
export const URL_S3 = 'https://d1ezvqt1a90tu9.cloudfront.net/';

export default http;

